import { UserListItemSkeleton } from '$common/user-list-item'

export function ChatListItemSkeleton() {
  return <UserListItemSkeleton size="large" />
}
